import { useParams } from '@tanstack/react-router';

/**
 * Returns the active `:orgSlug` URL param.
 *
 * Throws if called outside the `/orgs/$orgSlug/...` subtree. All current call
 * sites are mounted inside `orgRoute.beforeLoad`, which validates membership
 * before its children render — the throw is a runtime invariant guard, not a
 * recoverable error.
 */
export function useOrgSlug(): string {
  // Cross-cutting hook: callers exist in many parts of the org-scoped subtree,
  // so we use loose mode and narrow the cast to the only param this hook needs.
  const params = useParams({ strict: false }) as { orgSlug?: string };
  if (!params.orgSlug) {
    throw new Error('useOrgSlug() called outside the /orgs/$orgSlug subtree');
  }
  return params.orgSlug;
}
